import { create, type StoreApi } from 'zustand';
import { persist } from 'zustand/middleware';
import { STORAGE_KEYS } from '@/utils/constants';

let _setAuthState: StoreApi<AuthState>['setState'] | null = null;

interface User {
  id: string;
  phone?: string;
  nickname?: string;
  role: string;
  cost_discount?: number;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: User | null;
  isAuthenticated: boolean;
  hydrated: boolean;
  login: (accessToken: string, refreshToken: string, user: User) => void;
  setAccessToken: (token: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => {
      _setAuthState = set;
      return {
        accessToken: null,
        refreshToken: null,
        user: null,
        isAuthenticated: false,
        hydrated: false,
        login: (accessToken, refreshToken, user) => {
          localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
          localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
          localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
          set({ accessToken, refreshToken, user, isAuthenticated: true });
        },
        setAccessToken: (token) => {
          localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
          set({ accessToken: token });
        },
        logout: () => {
          localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
          localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
          localStorage.removeItem(STORAGE_KEYS.USER);
          set({ accessToken: null, refreshToken: null, user: null, isAuthenticated: false });
        },
      };
    },
    {
      name: 'auth-store',
      onRehydrateStorage: () => () => {
        _setAuthState?.({ hydrated: true });
      },
    }
  )
);
